// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"250":"2809a081","679":"67cacafa","813":"2809a081","954":"2809a081"}[chunkId] + ".chunk.css";
};